// @mui
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import { alpha } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Unstable_Grid2';
// routes
import { RouterLink } from 'src/routes/components';
import { usePathname } from 'src/routes/hooks';
// _mock
import { _socials } from 'src/_mock';
// components
import Iconify from 'src/components/iconify';
import Logo from 'src/components/logo';
import { HashLink } from 'react-router-hash-link';
import { paths } from 'src/routes/paths';

// ----------------------------------------------------------------------

const LINKS = [
  {
    headline: 'SiteSnap',
    children: [
      { name: 'About us', href: "/#about-us" },
      { name: 'Contact us', href: "/#contact-us" },
      { name: 'FAQs', href: "/#faqs" },
    ],
  },
  {
    headline: 'Legal',
    children: [
      { name: 'Terms and Condition', href: paths.terms },
      { name: 'Privacy Policy', href: paths.privacy },
    ],
  },
  {
    headline: 'Contact',
    children: [{ name: 'support@sitesnap.com', href: '#' }],
  },
];

// ----------------------------------------------------------------------

export default function Footer() {
  const pathname = usePathname();

  const isHome = pathname === '/';

  const simpleFooter = (
    <Box
      component="footer"
      sx={{
        py: 5,
        textAlign: 'center',
        position: 'relative',
        bgcolor: 'background.default',
      }}
    >
      <Container>
        <Logo sx={{ mb: 1, mx: 'auto' }} />

        <Typography variant="caption" component="div">
          © All rights reserved
          <br /> made by
          <Link href="https://minimals.cc/"> minimals.cc </Link>
        </Typography>
      </Container>
    </Box>
  );

  const mainFooter = (
    <Box
      component="footer"
      sx={{
        position: 'relative',
        bgcolor: 'background.default',
      }}
    >
      <Divider />

      <Container
        sx={{
          pt: 10,
          pb: 5,
          textAlign: { xs: 'center', md: 'unset' },
        }}
      >
        <Logo sx={{ mb: 3 }} />

        <Grid
          container
          justifyContent={{
            xs: 'center',
            md: 'space-between',
          }}
        >
          <Grid xs={8} md={3}>
            <Typography
              variant="body2"
              sx={{
                maxWidth: 270,
                mx: { xs: 'auto', md: 'unset' },
              }}
            >
              The easiest way to upload and manage your photos and files with SiteSnap — secure, fast, and ready to fit your needs.
            </Typography>

            <Stack
              direction="row"
              justifyContent={{ xs: 'center', md: 'flex-start' }}
              sx={{
                mt: 3,
                mb: { xs: 5, md: 0 },
              }}
            >
              {_socials.map((social) => (
                <IconButton
                  key={social.name}
                  sx={{
                    '&:hover': {
                      bgcolor: alpha(social.color, 0.08),
                    },
                  }}
                >
                  <Iconify color={social.color} icon={social.icon} />
                </IconButton>
              ))}
            </Stack>
          </Grid>

          <Grid xs={12} md={6}>
            <Stack spacing={5} direction={{ xs: 'column', md: 'row' }}>
              {LINKS.map((list) => (
                <Stack
                  key={list.headline}
                  spacing={2}
                  alignItems={{ xs: 'center', md: 'flex-start' }}
                  sx={{ width: 1 }}
                >
                  <Typography component="div" variant="overline">
                    {list.headline}
                  </Typography>

                  {list.children.map((link) => (
                    <HashLink
                      key={link.name}
                      to={link.href}
                      smooth
                      style={{ textDecoration: 'none' }}
                    >
                      <Typography
                        variant="body2"
                        color="text.primary"
                        sx={{
                          display: 'block',
                          fontWeight: 500,
                         
                        }}
                      >
                        {link.name}
                      </Typography>
                    </HashLink>
                  ))}

                </Stack>
              ))}
            </Stack>
          </Grid>
        </Grid>

        <Typography variant="body2" sx={{ mt: 10 }}>
          © {new Date().getFullYear()}. All rights reserved
        </Typography>
      </Container>
    </Box>
  );

  return isHome ? mainFooter : mainFooter;
}
